export default __webpack_public_path__ + "static/media/projectfeature1.df854a0b.png";